<p-dialog [visible]="isOpen()" [modal]="true" [closable]="false" [draggable]="false" [resizable]="false" styleClass="new-version-dialog" [style]="{ width: '50vw' }">
  <ng-template pTemplate="header">
    <div class="p-d-flex p-ai-center">
      <i class="fa fa-exclamation-circle mr-2"></i>
      <span class="p-dialog-title">{{ 'notification.newVersion.title' | translate }}</span>
    </div>
  </ng-template>
  <div class="p-d-flex p-ai-center p-jc-center p-flex-column">
    <p class="p-mt-3">
      {{ 'notification.newVersion.message' | translate }}
    </p>
  </div>
  <ng-template pTemplate="footer">
    <div class="p-d-flex p-jc-center w-full">
      <plyca-ui-button-generic [config]="{ buttonClass: 'btn btn-xs btn-secondary mr-2' }" (clickEvent)="later()">
        <i class="fa fa-times mr-2"></i>
        {{ 'notification.newVersion.later' | translate }}
      </plyca-ui-button-generic>
      <plyca-ui-button-generic [config]="{ buttonClass: 'btn btn-xs btn-primary' }" (clickEvent)="reload()">
        <i class="fa fa-refresh mr-2"></i>
        {{ 'notification.newVersion.reload' | translate }}
      </plyca-ui-button-generic>
    </div>
  </ng-template>
</p-dialog>
